import type { RouteRecordRaw } from 'vue-router'
import { legacyTenantRedirect } from './tenantScoped'
import { toTenantAdminPath } from '@/utils/tenantRoute'

const userRoutes: RouteRecordRaw[] = [
  {
    path: 't/:tenantCode/profile',
    name: 'profile',
    component: () => import('@/views/user/Profile.vue')
  },
  {
    path: 'profile',
    component: () => import('@/views/user/Profile.vue'),
    beforeEnter: legacyTenantRedirect,
    meta: { legacyTenantRedirect: true }
  },
  {
    path: 't/:tenantCode/subscription',
    redirect: route => `/admin/t/${encodeURIComponent(String(route.params.tenantCode || ''))}/subscription`
  },
  {
    path: 'subscription',
    redirect: () => toTenantAdminPath('/admin/subscription')
  }
]

export default userRoutes
